import usePermissions from "../../../hooks/usePermissions";
import { IContent } from "./IContent";

export const ContentComponent = ({ content }: { content?: IContent }) => {
  const { hasPermissions } = usePermissions();

  return content?.generateElement({ hasPermissions }) ?? null;
};
